import { areQuestionnairesEnabledForStage } from '@shared/config/feature-flags';
import { UserRoleTypes } from '@shared/constants/UserRoleTypes';
import { AvailableRolesState } from '@shared/redux/state/availableRoles';

export const initialAvailableRolesState = (): AvailableRolesState => ({
  portalRoles: [
    UserRoleTypes.PortalOrganisationManager,
    UserRoleTypes.PortalUserManager,
    UserRoleTypes.PreRegistrationManager,
  ],
  tenantRoles: [
    UserRoleTypes.Technician,
    UserRoleTypes.MedicalProfessional,
    UserRoleTypes.OrganisationManager,
    ...(areQuestionnairesEnabledForStage() ? [UserRoleTypes.QuestionnaireTemplateAdministrator] : []),
  ],
});
